import React, {PropsWithChildren, useCallback, useContext, useEffect, useState} from "react";
import {PreloaderContext} from "./PreloaderContext";
import {ServerDataContext} from "./ServerDataContext";
import {ThemeContext} from "./ThemeContext";

interface PreviewContextState {
    isPreviewMode: boolean;
    websocketUrl: string;
    isPreviewInited: boolean;
    searchString: string;
}

export const PreviewDataContext = React.createContext({} as PreviewContextState);

interface PreviewDataProviderProps extends PropsWithChildren{

}


export const PreviewProvider: React.FunctionComponent<PreviewDataProviderProps> = ({children}) => {
    const [isPreviewMode, setPreviewMode] = useState<boolean>(false);
    const [websocketUrl, setWebsocketUrl] = useState<string>('');
    const [isPreviewInited, setPreviewInited] = useState<boolean>(false);
    const [searchString, setSearchString] = useState<string>('');
    const preloaderContext = useContext(PreloaderContext);
    const serverDataContext = useContext(ServerDataContext);
    const themeContext = useContext(ThemeContext);

    useEffect(() => {
        const isPreview = (window as any).IS_PREVIEW as boolean;
        const websocketServerUrl = (window as any).WEBSOCKET_URL as string;
        setPreviewMode(isPreview || false);
        setWebsocketUrl(websocketServerUrl);
        setPreviewInited(true);
        setSearchString(window.location.search);
    }, [false]);

    const listenUpdates = useCallback(() => {
        if (isPreviewMode && websocketUrl) {
            const socket = new WebSocket(websocketUrl);

            socket.addEventListener('open', () => {
            })

            socket.addEventListener('message', (event) => {
                let data = JSON.parse(event.data) as { type: string, action: string, data: any };
                if (data.type === 'preloader') {
                    if (data.action === 'show') {
                        preloaderContext.showFullPagePreloader();
                    } else if (data.action === 'hide') {
                        preloaderContext.hideFullPagePreloader();
                    }
                } else if (data.type === 'invoice' && data.action === 'update') {
                    serverDataContext.setMetaData(data.data);
                } else if(data.type === 'theme' && data.action === 'update') {
                    themeContext.setTheme(data.data);
                }
            });

            return () => {
                socket.close()
            }
        }
    }, [isPreviewMode, websocketUrl]);

    useEffect(listenUpdates, [isPreviewMode, websocketUrl]);

    return <PreviewDataContext.Provider value={{isPreviewMode, websocketUrl, isPreviewInited, searchString}}>
        {children}
    </PreviewDataContext.Provider>
}